
export const workOrderPath = {
  'PRE_APPOINT_ROOM': '/MeasureRoomTask', // 量房,
  'EDIT_ROOM_PRE_INFO': '/MeasureRoomTask' // 量房,
}